import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl } from '../../../../Containers/Config/index.js';
import { GET_USER_ROLES, GET_USER_ROLES_SUCCESS, GET_USER_ROLES_ERROR } from '../actions';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getUserRoles({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v2/user-roles`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_USER_ROLES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_USER_ROLES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_USER_ROLES_ERROR, payload: error });
  }
}

export function* watchUserRoles() {
  yield takeEvery(GET_USER_ROLES, getUserRoles);
}

function* watchUserRolesSaga() {
  yield all([fork(watchUserRoles)]);
}

export default watchUserRolesSaga;
